import { LoadingButton } from "@mui/lab";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { useTranslation } from "react-i18next";

const DialogConfirmation = (props) => {
    const { t } = useTranslation();
    const { open, toggle, title, subtitle, onConfirm, loading } = props;

    return <>
        <Dialog open={open} onClose={toggle} maxWidth='xs' scroll="paper">
            <DialogTitle sx={{ textAlign: 'center' }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText textAlign={'center'}>
                    {subtitle || ''}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <LoadingButton loading={loading} variant="contained" fullWidth onClick={onConfirm}>
                    {t("Yes, Confirm")}
                </LoadingButton>    
                <Button variant="outlined" fullWidth onClick={toggle}>
                    {t("Cancel")}
                </Button>
            </DialogActions>
        </Dialog >
    </>
}

export default DialogConfirmation